// Need to use the React-specific entry point to import createApi
import { baseApiAuth } from "./baseApi";

// using CSRF token from Local Storage

// Define a service using a base URL and expected endpoints
export const agoraApi = baseApiAuth.injectEndpoints({
    reducerPath: "agoraApi",
    endpoints: (builder) => ({
        createToken: builder.mutation({
            query: (data) => {
                return {
                    url: `generate-agora-token`,
                    method: "POST",
                    headers: {
                        "Content-type": "application/json; charset=UTF-8",
                    },
                    body: data
                };
            },
        }),
    }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
    useCreateTokenMutation
} = agoraApi;
